import { Classes } from '@blueprintjs/core';
import { Chart } from 'app/components/charts/Chart';
import { css, styled } from 'styled-components';
import { PLOT_BAND_CLASS_NAME } from './use-events-chart-options/useEventsChartOptions';

export const StyledEventsChart = styled(Chart)`
  .${PLOT_BAND_CLASS_NAME} {
    cursor: pointer;
    &:hover {
      fill: ${({ theme }) => theme.colors.mono.ui04};
    }
  }
  ${({ theme }) =>
    theme.breakpoints.down(
      'md',
      css`
        min-height: 20ch;
      `
    )}
`;

export const EventsChartLoading = styled.div.attrs({ className: Classes.SKELETON })`
  height: 300px;
`;
